import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "viewer__bar" };
const _hoisted_2 = ["aria-pressed", "disabled"];
const _hoisted_3 = ["onKeydown"];
const _hoisted_4 = {
    key: 0,
    class: "viewer__count"
};
const _hoisted_5 = {
    key: 1,
    class: "viewer__count"
};
const _hoisted_6 = {
    key: 3,
    class: "viewer__results",
    role: "listbox"
};
const _hoisted_7 = {
    key: 0,
    class: "viewer__results-note"
};
const _hoisted_8 = { class: "viewer__results-doc" };
const _hoisted_9 = ["aria-selected", "onMousedown"];
const _hoisted_10 = { class: "viewer__result-page" };
const _hoisted_11 = { class: "viewer__result-text" };
const _hoisted_12 = {
    key: 1,
    class: "viewer__results-note viewer__results-note--scanned"
};
const _hoisted_13 = { class: "viewer__zoom" };
const _hoisted_14 = ["disabled"];
const _hoisted_15 = ["disabled"];
const _hoisted_16 = ["disabled"];
const _hoisted_17 = ["disabled"];
const _hoisted_18 = ["disabled"];
const _hoisted_19 = { class: "viewer__body" };
const _hoisted_20 = { class: "viewer__group-label" };
const _hoisted_21 = ["title", "onClick"];
const _hoisted_22 = { class: "viewer__rail-meta" };
const _hoisted_23 = { class: "viewer__rail-title" };
const _hoisted_24 = { class: "viewer__rail-sub" };
const _hoisted_25 = {
    key: 0,
    class: "viewer__new"
};
const _hoisted_26 = { key: 1 };
const _hoisted_27 = {
    key: 2,
    class: "viewer__bad"
};
const _hoisted_28 = { key: 4 };
const _hoisted_29 = {
    key: 5,
    title: "Scanned, so search can't read it."
};
const _hoisted_30 = {
    key: 6,
    class: "viewer__hitcount"
};
const _hoisted_31 = {
    key: 0,
    class: "viewer__pages"
};
const _hoisted_32 = ["aria-label", "onClick"];
const _hoisted_33 = { class: "viewer__pill-doc" };
const _hoisted_34 = { class: "viewer__pill-page" };
const _hoisted_35 = {
    key: 0,
    class: "viewer__state"
};
const _hoisted_36 = {
    key: 1,
    class: "viewer__state"
};
const _hoisted_37 = {
    key: 2,
    class: "viewer__state"
};
const _hoisted_38 = ["id", "data-divider"];
const _hoisted_39 = { class: "viewer__divider-title" };
const _hoisted_40 = { class: "viewer__divider-sub" };
const _hoisted_41 = {
    key: 0,
    class: "viewer__new"
};
const _hoisted_42 = {
    key: 0,
    class: "viewer__doc-error"
};
const _hoisted_43 = ["href"];
const _hoisted_44 = {
    key: 1,
    class: "viewer__doc-error"
};
const _hoisted_45 = ["href"];
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import DocumentPage from "@/components/paWorkspace/DocumentPage.vue";
import DocumentThumb from "@/components/paWorkspace/DocumentThumb.vue";
import { useDocumentSet } from "@/composables/useDocumentSet";
const MIN_SCALE = 0.4;
const MAX_SCALE = 3;
export default /*@__PURE__*/ _defineComponent({
    __name: 'DocumentViewer',
    props: {
        orderKey: {},
        mode: { default: "docked" },
        railOpen: { type: Boolean, default: true },
        since: { default: null }
    },
    emits: ["update:railOpen", "swap", "popout", "hide", "loaded"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const GROUP_LABELS = {
            response: "Payer responses",
            chart: "Chart",
            necessity: "Letters",
            form: "Forms",
        };
        const ZOOM_LEVELS = [50, 75, 100, 125, 150, 200];
        const set = useDocumentSet();
        const documents = set.documents;
        const status = set.status;
        const rootEl = ref(null);
        const rootWidth = ref(0);
        const scroller = ref(null);
        const searchInput = ref(null);
        const viewportWidth = ref(0);
        const viewportHeight = ref(0);
        const fit = ref("width");
        const manualScale = ref(1);
        const rotations = ref({});
        const currentDocKey = ref(null);
        const currentPage = ref(1);
        const query = ref("");
        const hits = ref([]);
        const currentHit = ref(0);
        const searching = ref(false);
        const resultsOpen = ref(false);
        const searchMode = ref("phrase");
        const maxWidth = computed(() => Math.max(612, ...documents.value.flatMap((doc) => doc.pages.map((p) => p.width))));
        const maxHeight = computed(() => Math.max(792, ...documents.value.flatMap((doc) => doc.pages.map((p) => p.height))));
        const scale = computed(() => {
            const widthFit = Math.max(MIN_SCALE, (viewportWidth.value - 48) / maxWidth.value);
            if (fit.value === "width")
                return Math.min(widthFit, 2);
            if (fit.value === "page")
                return Math.min(widthFit, Math.max(MIN_SCALE, (viewportHeight.value - 64) / maxHeight.value));
            return manualScale.value;
        });
        const zoomLabel = computed(() => fit.value === "width" ? "Fit width" : fit.value === "page" ? "Fit page" : `${Math.round(scale.value * 100)}%`);
        const currentDoc = computed(() => documents.value.find((doc) => doc.key === currentDocKey.value) ?? documents.value[0]);
        const groups = computed(() => ["response", "chart", "necessity", "form"]
            .map((id) => ({ id, label: GROUP_LABELS[id], documents: documents.value.filter((doc) => doc.group === id) }))
            .filter((group) => group.documents.length));
        const groupedHits = computed(() => {
            const byDoc = new Map();
            hits.value.forEach((hit, index) => {
                const [before, match, after] = hit.snippet.split("\u0000");
                const entry = byDoc.get(hit.docKey) ?? {
                    docKey: hit.docKey,
                    label: documents.value.find((doc) => doc.key === hit.docKey)?.label ?? "",
                    hits: [],
                };
                entry.hits.push({ ...hit, index, before, match, after });
                byDoc.set(hit.docKey, entry);
            });
            return [...byDoc.values()];
        });
        const scannedCount = computed(() => documents.value.filter((doc) => doc.hasText === false).length);
        function pageHits(docKey, pageNumber) {
            return hits.value
                .map((hit, index) => ({ hit, index }))
                .filter(({ hit }) => hit.docKey === docKey && hit.pageNumber === pageNumber)
                .map(({ hit, index }) => ({ start: hit.start, end: hit.end, current: index === currentHit.value }));
        }
        function hitCount(docKey) {
            return hits.value.filter((hit) => hit.docKey === docKey).length;
        }
        function pagesLabel(doc) {
            if (doc.kind === "file")
                return "Download only";
            if (doc.status === "loading")
                return "Opening";
            const count = doc.pages.length;
            return `${count} page${count === 1 ? "" : "s"}`;
        }
        function isNew(doc) {
            return Boolean(props.since && doc.receivedAt && Date.parse(doc.receivedAt) > Date.parse(props.since));
        }
        function relative(iso) {
            const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
            if (minutes < 1)
                return "just now";
            if (minutes < 60)
                return `${minutes}m ago`;
            const hours = Math.round(minutes / 60);
            if (hours < 24)
                return `${hours}h ago`;
            const days = Math.round(hours / 24);
            return days < 30 ? `${days}d ago` : new Date(iso).toLocaleDateString();
        }
        function pageElement(docKey, pageNumber) {
            return (scroller.value?.querySelector(`.doc-page[data-doc="${CSS.escape(docKey)}"][data-page="${pageNumber}"]`) ?? null);
        }
        let anchor = null;
        function scrollToPage(docKey, pageNumber, behavior = "smooth") {
            const target = pageNumber === 1
                ? scroller.value?.querySelector(`[data-divider="${CSS.escape(docKey)}"]`)
                : pageElement(docKey, pageNumber);
            if (!target || !scroller.value)
                return;
            cancelReveal();
            anchor = { docKey, pageNumber };
            scroller.value.scrollTo({ top: target.offsetTop - 8, behavior });
            currentDocKey.value = docKey;
            currentPage.value = pageNumber;
        }
        const pillVisible = ref(false);
        let pillTimer;
        let scrollFrame = 0;
        function onScroll() {
            pillVisible.value = true;
            clearTimeout(pillTimer);
            pillTimer = setTimeout(() => (pillVisible.value = false), 1200);
            if (scrollFrame)
                return;
            scrollFrame = requestAnimationFrame(() => {
                scrollFrame = 0;
                const el = scroller.value;
                if (!el)
                    return;
                const probe = el.scrollTop + el.clientHeight * 0.35;
                let found = null;
                for (const page of el.querySelectorAll(".doc-page")) {
                    if (page.offsetTop <= probe)
                        found = page;
                    else
                        break;
                }
                if (found) {
                    currentDocKey.value = found.dataset.doc ?? null;
                    currentPage.value = Number(found.dataset.page) || 1;
                }
            });
        }
        function anchorForZoom() {
            const el = scroller.value;
            const doc = currentDocKey.value;
            if (!el || !doc)
                return null;
            const page = pageElement(doc, currentPage.value);
            if (!page)
                return null;
            return {
                docKey: doc,
                pageNumber: currentPage.value,
                ratio: (el.scrollTop - page.offsetTop) / Math.max(page.offsetHeight, 1),
            };
        }
        async function applyZoom(change) {
            const anchor = anchorForZoom();
            change();
            await nextTick();
            if (!anchor || !scroller.value)
                return;
            const page = pageElement(anchor.docKey, anchor.pageNumber);
            if (page)
                scroller.value.scrollTop = page.offsetTop + anchor.ratio * page.offsetHeight;
        }
        function setZoom(value) {
            cancelReveal();
            applyZoom(() => {
                manualScale.value = Math.min(MAX_SCALE, Math.max(MIN_SCALE, value));
                fit.value = null;
            });
        }
        function zoomBy(direction) {
            setZoom(scale.value * (direction > 0 ? 1.2 : 1 / 1.2));
        }
        function cancelReveal() {
            revealPending = false;
            anchor = null;
        }
        function onWheel(event) {
            cancelReveal();
            if (!(event.ctrlKey || event.metaKey))
                return;
            event.preventDefault();
            const delta = Math.max(-40, Math.min(40, event.deltaY));
            setZoom(scale.value * Math.exp(-delta * 0.0025));
        }
        function rotate() {
            const key = currentDoc.value?.key;
            if (!key)
                return;
            cancelReveal();
            rotations.value = { ...rotations.value, [key]: ((rotations.value[key] || 0) + 90) % 360 };
        }
        function openOriginal() {
            if (currentDoc.value)
                window.open(currentDoc.value.url, "_blank", "noopener");
        }
        let searchTimer;
        let searchToken = 0;
        let revealPending = false;
        async function runSearch(jump = true) {
            const token = ++searchToken;
            const text = query.value.trim();
            if (text.length < 2) {
                hits.value = [];
                searching.value = false;
                return;
            }
            searching.value = true;
            const found = await set.search(text);
            if (token !== searchToken)
                return;
            hits.value = found.hits;
            searchMode.value = found.mode;
            currentHit.value = 0;
            searching.value = false;
            if (jump && found.hits.length)
                goToHit(0, true);
        }
        watch(query, () => {
            resultsOpen.value = true;
            clearTimeout(searchTimer);
            searchTimer = setTimeout(() => runSearch(), 180);
        });
        function goToHit(index, fresh = false) {
            if (!hits.value.length)
                return;
            const next = (index + hits.value.length) % hits.value.length;
            const unchanged = !fresh && next === currentHit.value;
            currentHit.value = next;
            anchor = null;
            revealPending = true;
            const hit = hits.value[next];
            const page = pageElement(hit.docKey, hit.pageNumber);
            const el = scroller.value;
            if (page &&
                el &&
                (page.offsetTop > el.scrollTop + el.clientHeight || page.offsetTop + page.offsetHeight < el.scrollTop)) {
                el.scrollTo({ top: page.offsetTop - 8 });
            }
            const painted = unchanged ? page?.querySelector(".doc-hit--current") : null;
            if (painted)
                revealMark(painted);
        }
        function step(direction) {
            resultsOpen.value = false;
            goToHit(currentHit.value + direction);
        }
        function revealMark(mark) {
            const el = scroller.value;
            if (!el || !revealPending || !mark.isConnected)
                return;
            revealPending = false;
            const markRect = mark.getBoundingClientRect();
            const viewRect = el.getBoundingClientRect();
            if (markRect.top < viewRect.top + 40 || markRect.bottom > viewRect.bottom - 40) {
                el.scrollBy({ top: markRect.top - viewRect.top - el.clientHeight * 0.35, behavior: "smooth" });
            }
        }
        function clearSearch() {
            query.value = "";
            hits.value = [];
            searchInput.value?.blur();
        }
        let resultsTimer;
        function closeResultsSoon() {
            clearTimeout(resultsTimer);
            resultsTimer = setTimeout(() => (resultsOpen.value = false), 120);
        }
        function focusSearch() {
            nextTick(() => {
                searchInput.value?.focus();
                searchInput.value?.select();
            });
        }
        function onKeydown(event) {
            const inInput = event.target.tagName === "INPUT";
            if (inInput || event.metaKey || event.ctrlKey || event.altKey)
                return;
            if (event.key === "+" || event.key === "=") {
                event.preventDefault();
                zoomBy(1);
            }
            else if (event.key === "-") {
                event.preventDefault();
                zoomBy(-1);
            }
            else if (event.key === "0") {
                event.preventDefault();
                fit.value = "width";
            }
        }
        async function reload() {
            cancelReveal();
            searchToken += 1;
            searching.value = false;
            hits.value = [];
            if (!props.orderKey) {
                set.dispose();
                currentDocKey.value = null;
                return;
            }
            rotations.value = {};
            currentDocKey.value = null;
            currentPage.value = 1;
            await set.load(props.orderKey);
            emit("loaded", documents.value.length);
            if (query.value.trim().length >= 2)
                runSearch(false);
        }
        watch(() => props.orderKey, () => {
            scroller.value?.scrollTo({ top: 0 });
            reload();
        }, { immediate: true });
        const roomForRail = computed(() => rootWidth.value >= 420);
        const compactRail = computed(() => rootWidth.value < 820);
        const showRail = computed(() => props.railOpen && roomForRail.value && documents.value.length > 0);
        watch(scale, () => {
            const held = anchor;
            if (held)
                nextTick(() => scrollToPage(held.docKey, held.pageNumber, "auto"));
        });
        let resizeObserver = null;
        onMounted(() => {
            resizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    if (entry.target === scroller.value) {
                        viewportWidth.value = entry.contentRect.width;
                        viewportHeight.value = entry.contentRect.height;
                    }
                    else {
                        rootWidth.value = entry.contentRect.width;
                    }
                }
            });
            if (scroller.value)
                resizeObserver.observe(scroller.value);
            if (rootEl.value)
                resizeObserver.observe(rootEl.value);
        });
        onBeforeUnmount(() => {
            resizeObserver?.disconnect();
            set.dispose();
            cancelAnimationFrame(scrollFrame);
            clearTimeout(pillTimer);
        });
        __expose({ focusSearch, scrollToPage, documents });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            return (_openBlock(), _createElementBlock("section", {
                ref_key: "rootEl",
                ref: rootEl,
                class: _normalizeClass(["viewer", { 'viewer--window': __props.mode === 'window' }]),
                "aria-label": "Patient documents",
                onKeydown: onKeydown
            }, [
                _createElementVNode("header", _hoisted_1, [
                    _createElementVNode("button", {
                        class: "viewer__icon",
                        "aria-pressed": showRail.value,
                        disabled: !roomForRail.value,
                        "aria-label": "Show document list",
                        title: "Document list",
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('update:railOpen', !__props.railOpen)))
                    }, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createTextVNode("mdi-dock-left", -1)
                                ]))]),
                            _: 1
                        })
                    ], 8, _hoisted_2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["viewer__search", { 'viewer__search--active': query.value }])
                    }, [
                        _createVNode(_component_v_icon, {
                            size: "16",
                            class: "viewer__search-icon"
                        }, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                    _createTextVNode("mdi-magnify", -1)
                                ]))]),
                            _: 1
                        }),
                        _withDirectives(_createElementVNode("input", {
                            ref_key: "searchInput",
                            ref: searchInput,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((query).value = $event)),
                            type: "search",
                            placeholder: "Search documents",
                            "aria-label": "Search documents",
                            onFocus: _cache[2] || (_cache[2] = ($event) => (resultsOpen.value = true)),
                            onBlur: closeResultsSoon,
                            onKeydown: [
                                _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event) => ($event.shiftKey ? step(-1) : step(1)), ["prevent"]), ["enter"])),
                                _withKeys(_withModifiers(clearSearch, ["prevent"]), ["esc"])
                            ]
                        }, null, 40, _hoisted_3), [
                            [_vModelText, query.value]
                        ]),
                        (query.value && !searching.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(hits.value.length ? `${currentHit.value + 1} of ${hits.value.length}` : "No matches"), 1))
                            : (searching.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Searching"))
                                : _createCommentVNode("", true),
                        (hits.value.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createElementVNode("button", {
                                    class: "viewer__icon viewer__icon--sm",
                                    "aria-label": "Previous match",
                                    onClick: _cache[4] || (_cache[4] = ($event) => (step(-1)))
                                }, [
                                    _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                _createTextVNode("mdi-chevron-up", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("button", {
                                    class: "viewer__icon viewer__icon--sm",
                                    "aria-label": "Next match",
                                    onClick: _cache[5] || (_cache[5] = ($event) => (step(1)))
                                }, [
                                    _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                _createTextVNode("mdi-chevron-down", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ])
                            ], 64))
                            : _createCommentVNode("", true),
                        (resultsOpen.value && query.value.trim().length >= 2 && !searching.value && (hits.value.length || scannedCount.value))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                (searchMode.value === 'words')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "No exact match. Showing each word."))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedHits.value, (group) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: group.docKey
                                    }, [
                                        _createElementVNode("div", _hoisted_8, _toDisplayString(group.label), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.hits, (hit) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: `${hit.docKey}:${hit.pageNumber}:${hit.start}`,
                                                class: _normalizeClass(["viewer__result", { 'viewer__result--current': hit.index === currentHit.value }]),
                                                role: "option",
                                                "aria-selected": hit.index === currentHit.value,
                                                onMousedown: _withModifiers(($event) => (goToHit(hit.index)), ["prevent"])
                                            }, [
                                                _createElementVNode("span", _hoisted_10, "p" + _toDisplayString(hit.pageNumber), 1),
                                                _createElementVNode("span", _hoisted_11, [
                                                    _createTextVNode(_toDisplayString(hit.before), 1),
                                                    _createElementVNode("mark", null, _toDisplayString(hit.match), 1),
                                                    _createTextVNode(_toDisplayString(hit.after), 1)
                                                ])
                                            ], 42, _hoisted_9));
                                        }), 128))
                                    ], 64));
                                }), 128)),
                                (scannedCount.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(scannedCount.value) + " scanned document" + _toDisplayString(scannedCount.value === 1 ? " wasn't" : "s weren't") + " searched. ", 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("button", {
                            class: "viewer__icon",
                            "aria-label": "Zoom out",
                            title: "Zoom out (−)",
                            disabled: !_unref(documents).length,
                            onClick: _cache[6] || (_cache[6] = ($event) => (zoomBy(-1)))
                        }, [
                            _createVNode(_component_v_icon, { size: "18" }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                        _createTextVNode("mdi-minus", -1)
                                    ]))]),
                                _: 1
                            })
                        ], 8, _hoisted_14),
                        _createVNode(_component_v_menu, {
                            location: "bottom end",
                            disabled: !_unref(documents).length
                        }, {
                            activator: _withCtx(({ props: menuProps }) => [
                                _createElementVNode("button", _mergeProps({ class: "viewer__pct" }, menuProps, {
                                    "aria-label": "Zoom options",
                                    disabled: !_unref(documents).length
                                }), _toDisplayString(zoomLabel.value), 17, _hoisted_15)
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_component_v_list, {
                                    density: "compact",
                                    class: "viewer__menu"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, {
                                            title: "Fit width",
                                            onClick: _cache[7] || (_cache[7] = ($event) => (fit.value = 'width'))
                                        }),
                                        _createVNode(_component_v_list_item, {
                                            title: "Fit page",
                                            onClick: _cache[8] || (_cache[8] = ($event) => (fit.value = 'page'))
                                        }),
                                        _createVNode(_component_v_divider),
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ZOOM_LEVELS, (level) => {
                                            return _createVNode(_component_v_list_item, {
                                                key: level,
                                                title: `${level}%`,
                                                onClick: ($event) => (setZoom(level / 100))
                                            }, null, 8, ["title", "onClick"]);
                                        }), 64))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["disabled"]),
                        _createElementVNode("button", {
                            class: "viewer__icon",
                            "aria-label": "Zoom in",
                            title: "Zoom in (+)",
                            disabled: !_unref(documents).length,
                            onClick: _cache[9] || (_cache[9] = ($event) => (zoomBy(1)))
                        }, [
                            _createVNode(_component_v_icon, { size: "18" }, {
                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                        _createTextVNode("mdi-plus", -1)
                                    ]))]),
                                _: 1
                            })
                        ], 8, _hoisted_16)
                    ]),
                    _createElementVNode("button", {
                        class: "viewer__icon",
                        "aria-label": "Rotate page",
                        title: "Rotate document",
                        disabled: !currentDoc.value,
                        onClick: rotate
                    }, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                    _createTextVNode("mdi-rotate-right", -1)
                                ]))]),
                            _: 1
                        })
                    ], 8, _hoisted_17),
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "viewer__sep" }, null, -1)),
                    (__props.mode !== 'window')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (__props.mode === 'docked')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "viewer__icon",
                                    "aria-label": "Move documents to the other side",
                                    title: "Other side (\\)",
                                    onClick: _cache[10] || (_cache[10] = ($event) => (emit('swap')))
                                }, [
                                    _createVNode(_component_v_icon, { size: "18" }, {
                                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                                _createTextVNode("mdi-swap-horizontal", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("button", {
                                class: "viewer__icon",
                                "aria-label": "Open in a new window",
                                title: "Open in a new window",
                                onClick: _cache[11] || (_cache[11] = ($event) => (emit('popout')))
                            }, [
                                _createVNode(_component_v_icon, { size: "18" }, {
                                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                            _createTextVNode("mdi-open-in-new", -1)
                                        ]))]),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("button", {
                                class: "viewer__icon",
                                "aria-label": "Hide documents",
                                title: "Hide documents (D)",
                                onClick: _cache[12] || (_cache[12] = ($event) => (emit('hide')))
                            }, [
                                _createVNode(_component_v_icon, { size: "18" }, {
                                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                            _createTextVNode("mdi-close", -1)
                                        ]))]),
                                    _: 1
                                })
                            ])
                        ], 64))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "viewer__icon",
                            "aria-label": "Open original",
                            title: "Open original file",
                            disabled: !currentDoc.value,
                            onClick: openOriginal
                        }, [
                            _createVNode(_component_v_icon, { size: "18" }, {
                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                        _createTextVNode("mdi-file-download-outline", -1)
                                    ]))]),
                                _: 1
                            })
                        ], 8, _hoisted_18))
                ]),
                _createElementVNode("div", _hoisted_19, [
                    (showRail.value)
                        ? (_openBlock(), _createElementBlock("aside", {
                            key: 0,
                            class: _normalizeClass(["viewer__rail", { 'viewer__rail--compact': compactRail.value }]),
                            "aria-label": "Documents"
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: group.id,
                                    class: "viewer__group"
                                }, [
                                    _createElementVNode("div", _hoisted_20, _toDisplayString(group.label), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.documents, (doc) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: doc.key,
                                            class: _normalizeClass(["viewer__rail-doc", { 'viewer__rail-doc--current': doc.key === currentDoc.value?.key }]),
                                            title: compactRail.value ? `${doc.label} · ${pagesLabel(doc)}` : undefined,
                                            onClick: ($event) => (scrollToPage(doc.key, 1))
                                        }, [
                                            _createVNode(DocumentThumb, {
                                                "doc-key": doc.key,
                                                kind: doc.kind,
                                                url: doc.url,
                                                size: doc.pages[0],
                                                width: 44,
                                                "get-proxy": _unref(set).proxy
                                            }, null, 8, ["doc-key", "kind", "url", "size", "get-proxy"]),
                                            _createElementVNode("span", _hoisted_22, [
                                                _createElementVNode("span", _hoisted_23, _toDisplayString(doc.label), 1),
                                                _createElementVNode("span", _hoisted_24, [
                                                    (isNew(doc))
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "New"))
                                                        : _createCommentVNode("", true),
                                                    (doc.kind === 'file')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Download only"))
                                                        : (doc.status === 'error')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Could not open"))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                _createTextVNode(_toDisplayString(pagesLabel(doc)), 1)
                                                            ], 64)),
                                                    (doc.receivedAt)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "· " + _toDisplayString(relative(doc.receivedAt)), 1))
                                                        : _createCommentVNode("", true),
                                                    (doc.hasText === false)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, "· Scanned"))
                                                        : _createCommentVNode("", true),
                                                    (hitCount(doc.key))
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, "· " + _toDisplayString(hitCount(doc.key)) + " found", 1))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ])
                                        ], 10, _hoisted_21));
                                    }), 128)),
                                    (group.documents.some((d) => d.key === currentDocKey.value) && currentDoc.value && currentDoc.value.pages.length > 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentDoc.value.pages.length, (n) => {
                                                return (_openBlock(), _createElementBlock("button", {
                                                    key: n,
                                                    class: _normalizeClass(["viewer__pagechip", { 'viewer__pagechip--on': n === currentPage.value }]),
                                                    "aria-label": `Page ${n}`,
                                                    onClick: ($event) => (scrollToPage(currentDoc.value.key, n))
                                                }, _toDisplayString(n), 11, _hoisted_32));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]));
                            }), 128))
                        ], 2))
                        : _createCommentVNode("", true),
                    (currentDoc.value && _unref(documents).length)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["viewer__pill", { 'viewer__pill--show': pillVisible.value }]),
                            "aria-hidden": "true"
                        }, [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(currentDoc.value.label), 1),
                            _createElementVNode("span", _hoisted_34, _toDisplayString(currentPage.value) + " / " + _toDisplayString(Math.max(currentDoc.value.pages.length, 1)), 1)
                        ], 2))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        ref_key: "scroller",
                        ref: scroller,
                        class: "viewer__scroll",
                        tabindex: "-1",
                        onScrollPassive: onScroll,
                        onWheel: onWheel,
                        onPointerdown: cancelReveal,
                        onTouchstartPassive: cancelReveal,
                        onKeydown: cancelReveal
                    }, [
                        (_unref(status) === 'loading')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createVNode(_component_v_progress_circular, {
                                    indeterminate: "",
                                    size: "22",
                                    width: "2",
                                    color: "primary"
                                }),
                                _cache[25] || (_cache[25] = _createElementVNode("span", null, "Loading documents", -1))
                            ]))
                            : (_unref(status) === 'error')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createVNode(_component_v_icon, {
                                        size: "22",
                                        color: "error"
                                    }, {
                                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                                _createTextVNode("mdi-alert-circle-outline", -1)
                                            ]))]),
                                        _: 1
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(_unref(set).error.value), 1),
                                    _createElementVNode("button", {
                                        class: "viewer__link",
                                        onClick: reload
                                    }, "Try again")
                                ]))
                                : (_unref(status) === 'ready' && !_unref(documents).length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                        _createVNode(_component_v_icon, {
                                            size: "26",
                                            class: "viewer__state-icon"
                                        }, {
                                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                    _createTextVNode("mdi-file-document-outline", -1)
                                                ]))]),
                                            _: 1
                                        }),
                                        _cache[28] || (_cache[28] = _createElementVNode("strong", null, "No documents on this PA yet", -1)),
                                        _cache[29] || (_cache[29] = _createElementVNode("span", null, "Chart notes, letters, and payer faxes appear here when attached.", -1))
                                    ]))
                                    : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(documents), (doc) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                                key: doc.key
                            }, [
                                _createElementVNode("div", {
                                    id: `doc-${doc.key}`,
                                    class: "viewer__divider",
                                    "data-divider": doc.key
                                }, [
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(doc.label), 1),
                                    _createElementVNode("span", _hoisted_40, [
                                        _createTextVNode(_toDisplayString(GROUP_LABELS[doc.group]) + " · " + _toDisplayString(pagesLabel(doc)), 1),
                                        (doc.receivedAt)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(" · received " + _toDisplayString(relative(doc.receivedAt)), 1)
                                            ], 64))
                                            : _createCommentVNode("", true),
                                        (doc.hasText === false)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(" · Scanned, not searchable")
                                            ], 64))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (isNew(doc))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, "New since your last visit"))
                                        : _createCommentVNode("", true)
                                ], 8, _hoisted_38),
                                (doc.kind === 'file')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                        _cache[30] || (_cache[30] = _createElementVNode("span", null, "This file type can't be shown here.", -1)),
                                        _createElementVNode("a", {
                                            href: doc.url,
                                            target: "_blank",
                                            rel: "noopener",
                                            class: "viewer__link"
                                        }, "Download the original", 8, _hoisted_43)
                                    ]))
                                    : (doc.status === 'error')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            _cache[31] || (_cache[31] = _createElementVNode("span", null, "This document could not be opened here.", -1)),
                                            _createElementVNode("a", {
                                                href: doc.url,
                                                target: "_blank",
                                                rel: "noopener",
                                                class: "viewer__link"
                                            }, "Open the original", 8, _hoisted_45)
                                        ]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doc.pages, (size, index) => {
                                                return (_openBlock(), _createBlock(DocumentPage, {
                                                    key: `${doc.key}:${index}`,
                                                    "doc-key": doc.key,
                                                    "page-number": index + 1,
                                                    kind: doc.kind,
                                                    url: doc.url,
                                                    size: size,
                                                    scale: scale.value,
                                                    rotation: rotations.value[doc.key] || 0,
                                                    hits: pageHits(doc.key, index + 1),
                                                    root: scroller.value,
                                                    "get-proxy": _unref(set).proxy,
                                                    "get-text": _unref(set).pageText,
                                                    onCurrentMark: revealMark
                                                }, null, 8, ["doc-key", "page-number", "kind", "url", "size", "scale", "rotation", "hits", "root", "get-proxy", "get-text"]));
                                            }), 128)),
                                            (doc.status === 'loading')
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "viewer__doc-loading",
                                                    style: _normalizeStyle({ height: `${Math.round(792 * scale.value)}px` })
                                                }, null, 4))
                                                : _createCommentVNode("", true)
                                        ], 64))
                            ], 64));
                        }), 128))
                    ], 544)
                ])
            ], 34));
        };
    }
});
